// Simple event emitter for branch changes
// This allows any component to subscribe to branch changes without page refresh

import React from 'react';

interface Branch {
  id: string;
  name: string;
  location?: string;
  isDefault: boolean;
}

type BranchChangeListener = (branch: Branch) => void;

class BranchChangeEmitter {
  private listeners: Set<BranchChangeListener> = new Set();

  subscribe(listener: BranchChangeListener): () => void {
    this.listeners.add(listener);
    // Return unsubscribe function
    return () => {
      this.listeners.delete(listener);
    };
  }

  emit(branch: Branch): void {
    console.log('[BranchChangeEvent] Emitting branch change event:', branch.id, branch.name);
    this.listeners.forEach((listener) => {
      try {
        listener(branch);
      } catch (error) {
        console.error('[BranchChangeEvent] Error in listener:', error);
      }
    });
  }
}

export const branchChangeEmitter = new BranchChangeEmitter();

// Hook to subscribe to branch changes
export function useBranchChangeListener(callback: (branch: Branch) => void) {
  React.useEffect(() => {
    const unsubscribe = branchChangeEmitter.subscribe(callback);
    return unsubscribe;
  }, [callback]);
}
